import SfmcContainer from './code/Scripts/Components/SfmcContainer/sfmc-container.vue';

export default {
  components: {
    SfmcContainer,
  },
};
